import { Component, Input } from '@angular/core';
import { TranslationService } from '../../../../translations';

@Component({
    selector: 'billing-contact-details',
    template: `
        @if (billingContact) {
            <div>
                <div class="title">
                    {{
                        TR.key('subscription-manager.overview-billing-contact')
                    }}
                </div>
                <dl class="inlineDL">
                    <dd class="content">
                        {{ billingContact }}
                    </dd>
                </dl>
            </div>
        }
    `,
    styleUrls: ['../overview.component.less'],
    standalone: false
})
export class AccountSubscriptionManagerBillingContactComponent {
    @Input()
    billingContact: string;

    constructor(public TR: TranslationService) {}
}
